<template>
  <ul>
    <li v-for="(item, index) in items" :key="index" class="chatSettingMenuItem" :class="item.type" @click="item.method">
      <span class="chatMenuIcon"
        :style="{ 'background': `url(${baseSportIconsUrl}) ${item.sp_icon_width}px ${item.sp_icon_height}px/ 225px 199px` }" />
      <span>{{ item.alt }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  props: [
    'items'
  ],
  computed: {
    baseSportIconsUrl() {
      const hostname = window.location.hostname;
      const domains = [
        'nmd.co',
        'named.com',
        'xn--950bo4em5v.co',
        'named.net',
        'named2.net',
        'named2.kr'
      ]
      const rootDomain = domains.find(domain => hostname.includes(domain)) || domains[0]

      return `https://image.${rootDomain}/portal/sp_chat_icons.png?v=1`;
    }
  }
}
</script>

<style lang="scss">
.chatSettingMenuItem {
  list-style: none;
  font-family: '맑은 고딕' Gulim, sans-serif;
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  padding-left: 20px;
  cursor: pointer;

  &:hover {
    background-color: rgba(235, 238, 243, 0.5);
  }

  span {
    img {
      width: 15px;
      vertical-align: middle;
      margin-right: 20px;
    }
  }

  .chatMenuIcon {
    display: inline-block;
    width: 15px;
    height: 17px;
    margin-right: 20px;
    position: relative;
    top: 4px;
  }

}
</style>



// WEBPACK FOOTER //
// chat-setting-menu-item-new.vue?6980ff93